import React from "react";
import { Controller } from "react-hook-form";
import get from "lodash/get";
import { StyledInput } from "./Input.style";
import clsx from "clsx";
import InputMask from "react-input-mask";

const Input = (props, ref) => {
  const { name, control, normalizes, mask, className, ...rest } = props;

  const onChangeHandler =
    ({ onChange }) =>
    (e) => {
      const val = e.target.value;
      const isPassRule =
        (normalizes && normalizes.every((normalize) => normalize(val))) ?? true;
      if (val && !isPassRule) {
        return;
      }
      onChange(val);
    };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, formState: { errors } }) => {
        const errorMsg = get(errors, `${name}.message`, undefined);

        return (
          <>
            <InputMask
              mask={mask}
              value={field.value}
              onChange={onChangeHandler({ onChange: field.onChange })}
              className={`${className} ${clsx({
                "border-vekin-red100": Boolean(errorMsg),
              })}`}
              {...rest}
            >
              <StyledInput
                name={field.name}
                // ref={null}
              />
            </InputMask>
            {errorMsg ? (
              <label className="label !py-1 text-vekin-message-error">
                <span className="label-text-alt text-vekin-message-error">
                  {errorMsg}
                </span>
              </label>
            ) : null}
          </>
        );
      }}
    />
  );
};

Input.displayName = "Input";

export default Input;
